import React, { useMemo } from 'react'
import MerchandiseOfferCarousel from './MerchandiseOfferCarousel'
import useRecentlyViewedMerchandise from 'hooks/Merchandise/useRecentlyViewedMerchandise'
import { without } from 'lib/array/arrayUtils'
import { useIntl } from 'react-intl'

interface Props {
  trackingPageName: string
  /**
   * Optional: IDs to exclude from the list (e.g., current offer being viewed)
   */
  excludeIds?: Array<string>
}

const DEFAULT_EXCLUDE_IDS: Array<string> = []

function MerchandiseRecentlyViewedCarousel(props: Props) {
  const intl = useIntl()
  const { trackingPageName, excludeIds = DEFAULT_EXCLUDE_IDS } = props
  const [recentlyViewedIds, fetchingRecentlyViewed] = useRecentlyViewedMerchandise()

  const filteredIds = useMemo(() => {
    return excludeIds.length > 0
      ? without(recentlyViewedIds, ...excludeIds)
      : recentlyViewedIds
  }, [recentlyViewedIds, excludeIds])

  const title = intl.formatMessage({
    id: 'pg/CUaiKw6',
    defaultMessage: 'Recently viewed',
    description: 'Title for recently viewed merchandise carousel',
  })

  if (filteredIds.length === 0) {
    return null
  }

  return <MerchandiseOfferCarousel
    title={title}
    overrideList={filteredIds.map(id => ({ id, variantIds: [] }))}
    overrideFetching={fetchingRecentlyViewed}
    trackingListName="Recently viewed"
    trackingPageName={trackingPageName}
  />
}

export default MerchandiseRecentlyViewedCarousel
